function init () {
  const pupils = document.querySelectorAll('.c-face__iris')

  pupils.forEach(pupil => {
    const offset = pupil.getBoundingClientRect()
    pupil['centerX'] = offset.left
    pupil['centerY'] = offset.top
  })

  function goGoogly (e) {
    let pointerEvent = e
    let mouseX
    let mouseY

    if (e.targetTouches && e.targetTouches[0]) {
      // e.preventDefault()
      pointerEvent = e.targetTouches[0]
      mouseX = pointerEvent.pageX
      mouseY = pointerEvent.pageY
    } else {
      mouseX = e.clientX
      mouseY = e.clientY - 10
    }

    pupils.forEach(pupil => {
      pupil['radians'] = Math.atan2(mouseX - pupil['centerX'], mouseY - pupil['centerY'])
      pupil['degree'] = (pupil['radians'] * (180 / Math.PI) * -1)
      pupil.style.transform = 'rotate(' + (pupil['degree'] + 180) + 'deg)'
    })
  }

  window.addEventListener('mousemove', goGoogly)
  window.addEventListener('touchstart', goGoogly)
  window.addEventListener('touchmove', goGoogly)
}

export default init
